import React, { useState, useEffect, useRef } from "react";
import { Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import './ContentCarousel.css';

export default function ContentCarousel({headerSlides, contentSlides, setModalOpen}) {

    const [controlledSwiper, setControlledSwiper] = useState(null);
    const [mainSwiper, setMainSwiper] = useState(null);
    const swiperHeaderRef = useRef(null);
    const swiperMainRef = useRef(null);
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (mainSwiper) {
            //mainSwiper.loopDestroy();
            //mainSwiper.loopCreate();
        }
    }, [mainSwiper]);

    const handleHeaderPrev = () => {
        if (swiperHeaderRef.current) {
            swiperHeaderRef.current.swiper.slidePrev();
        }
    }

    const handleHeaderNext = () => {
        console.log('next');
        if (swiperHeaderRef.current) {
            swiperHeaderRef.current.swiper.slideNext();
        }
    }

    // mobile / desktop
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    function handleResize() {
        if (window.innerWidth < 768) {
            setMobile(true);
        }
    };

    useEffect(() => {
        if (mobile) {
            
        }
    }, [mobile]);

    return (
        <div className="contentCarousel">
            <div className="contentCarouselHeader">
                <Swiper 
                    modules={[Controller]}
                    controller={{ control: controlledSwiper }}
                    slidesPerView={mobile ? 1 : 3}
                    loop={false}
                    centeredSlides={true}
                    onSwiper={setMainSwiper}
                    ref={swiperHeaderRef}
                    slideToClickedSlide={true}
                >
                    {headerSlides.map((headerSlideContent, index) => (
                        <SwiperSlide key={headerSlideContent} virtualIndex={index}>
                            <h1>{headerSlideContent}</h1>
                        </SwiperSlide>
                    ))}
                    <a className="header-prev" onClick={handleHeaderPrev}><img src={require('../../assets/arrow_left.svg').default} alt="left-arrow" /></a>
                    <a className="header-next" onClick={handleHeaderNext}><img src={require('../../assets/arrow_right.svg').default} alt="right-arrow" /></a>
                </Swiper>
            </div>

            <div className="contentCarouselSlide">
                <Swiper 
                    modules={[Controller]} 
                    onSwiper={setControlledSwiper}
                    slidesPerView={1}
                    loop={true}
                    allowTouchMove={false}
                >
                    {contentSlides.map((contentSlideContent, index) => (
                        <SwiperSlide key={contentSlideContent} virtualIndex={index} setModalOpen={setModalOpen}>
                            {contentSlideContent}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>


        </div>
    );
}